/**
 * UpdateUserAccessComponent
 * Manages the removal of user access through the user profile access component.
 *
 * @author Muhammad Hamza Khan
 * @since December 4th, 2023
 */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CONSTANTS } from 'src/app/shared/constants/constants';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';

@Component({
  selector: 'app-update-user-access',
  templateUrl: './update-user-access.component.html',
  styleUrls: ['./update-user-access.component.scss'],
})
export class UpdateUserAccessComponent implements OnInit {
  @Input() commonAccessControl!: boolean;
  @Input() siteTimeZone!: string;
  @Input() userAccess!: any;
  @Output() editAccessEmmiter = new EventEmitter<any>();
  readonly CONSTANTS = CONSTANTS;
  readonly LANG_CONST = LANG_CONST;

  ngOnInit(): void {
    if (!this.commonAccessControl) {
      delete this.userAccess.otherAccess;
    }
  }
  /**
   * Emits the edit access event when a user access is edited.
   * @param access - The user access to be edited.
   */
  editAccess(access: any) {
    this.editAccessEmmiter.emit(access);
  }
}
